import moment from "moment";
import React from "react";
import IconImg from "../../asstes/tumblr.png";

function TumblrCard({ data }) {
  function linkify(inputText) {
    var replacedText, replacePattern1, replacePattern2, replacePattern3;

    //URLs starting with http://, https://, or ftp://
    replacePattern1 =
      /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    replacedText = inputText.replace(
      replacePattern1,
      '<a href="$1" target="_blank">$1</a>'
    );

    //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(
      replacePattern2,
      '$1<a href="http://$2" target="_blank">$2</a>'
    );

    //Change email addresses to mailto:: links.
    replacePattern3 =
      /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
    replacedText = replacedText.replace(
      replacePattern3,
      '<a href="mailto:$1">$1</a>'
    );

    return replacedText;
  }

  return (
    <div className="react_card_wrapper relative">
      <div className="card_icon">
        <img src={IconImg} alt="Tumblr" />
      </div>
      {data.type === "photo" && (
        <div className="reddit_img">
          <img src={data.photos[0].original_size.url} alt={data.blog_name} />
        </div>
      )}

      <div className="reddit_body">
        <h4 className="yt_title">{data.title}</h4>
        <span className="yt_description">{data.summary}</span>

        {data.tags.length > 0 && (
          <div className="yt_tags">
            {data.tags.map((tag, index) => (
              <span className="tag" key={index}>
                #{tag}
              </span>
            ))}
          </div>
        )}
        <span className="yt_date">
          {moment(data.date).format("MMMM Do YYYY")}
        </span>
      </div>
      <div className="twitter_card_footer flex justify-between">
        <a
          href={data.short_url}
          target="_blank"
          className="twitter_button yt_tmb"
        >
          View Post
        </a>
      </div>
    </div>
  );
}

export default TumblrCard;
